import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 36467 27350"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#000}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M30698 16026h-3205c-2515 0-3341 20-3915 2641-103 470 8 881 249 1238 285 419 732 608 1244 608-7 338-591 2507-712 2991-206 821-712 2496-712 3276 0 119 157 331 242 399 151 123 328 171 541 171 738 0 776-795 911-1368l1368-5469h5413l397 1811c142 643 254 1181 401 1807 134 572 265 1237 399 1809 199 853 151 1410 1011 1410 324 0 713-338 713-641 0-430-845-4044-1012-4758l-342-1581c760-63 1450-993 1573-1917 132-1000 303-2075 416-3074 131-1170 789-5465 789-6405 0-831-786-1424-1781-1424-828 0-1329 42-1804 688-172 235-172 259-247 537l-1296 4829c-199 810-451 1605-641 2422zM0 8974c0 742 667 5474 779 6272 195 1377 280 3624 918 4424 215 269 659 665 1081 700-54 644-1354 5732-1354 6268 0 411 348 712 855 712 672 0 724-798 855-1353l1211-5484h5413l1368 5470c233 933 183 1367 1125 1367 164 0 468-211 563-511 136-430-432-2240-549-2708-147-590-861-3254-869-3618 297 0 451-17 664-119 573-276 973-964 878-1561-47-296-245-1042-339-1304-572-1591-2135-1503-3482-1503H5769L3856 8822c-522-1730-2698-1363-3290-919-150 112-254 252-366 417C74 8506 0 8680 0 8974zM17806 4630c0 762-518 713-1131 934-210 76-445 207-675 322-288 146-931 622-1125 869-156 198-270 393-490 511-479 257-1083-40-1116-578-44-692 1381-1720 1915-2045 400-244 1659-847 2168-634 247 104 454 302 454 621zM15954 712c0 936 792 855 1496 855v712c-1188 277-1247 158-2493 713-1958 871-3501 2808-4078 4901-62 227-214 512 90 512h14529c350 0 76-642-81-1059-562-1501-1196-2325-2356-3342-1381-1211-2472-1359-4044-1725v-712c704 0 1496 81 1496-855 0-400-312-712-713-712h-3134c-400 0-712 312-712 712z"
        className="fil0"
      />
      <path
        d="M6838 10541c0 1408-272 2422 926 2422h20156c1206 0 997-1155 997-2137 0-623-374-997-997-997H7764c-469 0-926 250-926 712zM14387 26424c0 469 250 926 712 926h6268c573 0 1312-1132 0-1995-1802-1185-1568-859-1567-2064l2-8193c12-932 374-711-2922-711-351 0-214 866-214 1567v7265c2 1274 258 932-1524 2108-403 266-755 460-755 1097z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
